import React from 'react';

const InlineLoader = () => {
  return (
    <div className="flex items-center justify-center p-8 w-full">
      <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
      <span className="ml-3 text-sm font-medium text-gray-600">Loading</span>
    </div>
  );
};

export default InlineLoader;
